import { useState } from 'react'
import { CustomerApplication } from '../../../utilities/CustomerData'

export function ApplicationNetIncome({ _customerApplication, handleApplicationNetIncome }) {
  const customerApplication = new CustomerApplication(_customerApplication)
  const [netIncome, setNetIncome] = useState(customerApplication.netIncome)
  
    return (
      <div className='w-full h-full flex flex-col items-center justify-center px-4 py-6 mt-4'>
        <p className='lg:text-2xl text-xl font-bold text-center mb-16'>
          In 2021, what was your approximate net income, after taxes and deductions, from self-employment?
        </p>
        <div className='relative flex items-center gap-4 lg:w-1/2 w-full mb-10'>
          <span className='text-gray-700'>$0</span>
          <input
            type='range'
            id='dateSlider'
            min='0'
            max='250000'
            step='10000'
            value={netIncome}
            onChange={(e) => setNetIncome(Number(e.target.value))}
            className='w-full h-2 bg-gray-300 rounded-lg outline-none appearance-none slider-thumb'
            style={{
              background: `linear-gradient(to right, #74be43 ${((netIncome / 250000) * 100)}%, #ddd ${((netIncome / 250000) * 100)}%)`,
            }}
          />
          <div className='absolute -top-8 lg:left-[44%] left-[32%]'>
            <span className='bg-white text-gray-700 border border-gray-300 px-2 py-1 rounded-lg shadow-sm'>
              ${netIncome.toLocaleString()}
            </span>
          </div>
          <span className='text-gray-700'>$250,000</span>
        </div>
        <div className='flex flex-row items-center gap-4'>
          <button
            onClick={() => handleApplicationNetIncome(netIncome)}
            disabled={netIncome === 0}
            className={`px-8 py-2 text-white rounded-md transition-colors duration-200 ${netIncome === 0 ? 'bg-gray-400 cursor-not-allowed' : 'bg-primaryColor hover:bg-primaryDarkColor'}`}>
            Next
          </button>
        </div>
      </div>
    )
}